module.exports = __webpack_public_path__ + "static/verobw-0beddea60daf84a41e027e9f07c03578.png";